// API
import { api } from '../configs/api/api';

// Models
import { IThemeSettings, IWidgetInfo, IWidgetSettings } from '../interfaces/widget-settings.interfaces';

export const WidgetSettingsService = {
  fetchWidgetSettings: async (): Promise<{ widget_settings?: IWidgetInfo, error?: string }> => {
    try {
      const axiosResponse = await api.get('/company/widget');
      return axiosResponse.data;
    } catch (error: any) {
      if (!error?.response) {
        return { error: 'API not found' };
      }
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateWidgetTheme: async (theme_settings: IThemeSettings): Promise<{
    widget_settings?: IWidgetInfo,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.post('/company/update-widget-theme', theme_settings);
      return axiosResponse.data;
    } catch (error: any) {
      if (!error?.response) {
        return { error: 'API not found' };
      }
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateWidgetSettings: async (settings: IWidgetSettings): Promise<{ widget_settings?: IWidgetInfo, error?: string }> => {
    try {
      const axiosResponse = await api.post('/company/update-widget-settings', settings);
      return axiosResponse.data;
    } catch (error: any) {
      if (!error?.response) {
        return { error: 'API not found' };
      }
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
}
